import HeaderNav from './HeaderNav';

export default class HeaderStandard {
  constructor(section) {
    this.el = section.el;
    this.data = section.data;

    this.sticky = this.data.sticky;
    this.transparent = this.data.transparent;

    this.abortController = new AbortController();

    this.header = this.el.querySelector('[data-site-header]');
    this.headerLogo = this.el.querySelector('[data-header-logo]');
    this.logoImage = this.el.querySelector('[data-logo-image]');
    this.logoImageTransparent = this.el.querySelector('[data-logo-image-transparent]');
    this.logoImageMobile = this.el.querySelector('[data-logo-image-mobile]');
    this.cartCount = this.el.querySelector('[data-cart-count]');

    this.scrollObserver = null;
    this.scrollObserverPoint = this.el.querySelector('[data-header-scroll-observer]');

    // We need to place the scroll observer point to be outside of the header within the body tag.
    document.body.appendChild(this.scrollObserverPoint);

    this._setTransparency = this._setTransparency.bind(this);

    const { signal } = this.abortController;
    window.addEventListener('resize', () => this._recordSizeVariables(), { signal });
    this.header.addEventListener('rimg:load', () => this._recordSizeVariables(), { signal });

    document.addEventListener('cart:count', (e) => this._updateCartCount(e), { signal });

    // In the editor, listen for events when another section is moved (in case it is first)
    window.addEventListener('shopify:section:reorder', () => this._initTransparency(), { signal });

    this._initTransparency();
    this._recordSizeVariables();

    this.headerNav = new HeaderNav({
      header: this.header,
    });
  }

  _recordSizeVariables() {
    this._recordHeaderHeight();
    this._recordLogoWidth();
  }

  _recordHeaderHeight() {
    document.body.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  _recordLogoWidth() {
    // If the image exists and is visible, record its width in a CSS variable.
    if (this.logoImage && this.logoImage.offsetParent) {
      this.header.style.setProperty('--logo-width', `${this.logoImage.getBoundingClientRect().width}px`);
    } else if (this.logoImageTransparent && this.logoImageTransparent.offsetParent) {
      this.header.style.setProperty('--logo-width', `${this.logoImageTransparent.getBoundingClientRect().width}px`);
    } else if (this.logoImageMobile && this.logoImageMobile.offsetParent) {
      this.header.style.setProperty('--logo-width', `${this.logoImageMobile.getBoundingClientRect().width}px`);
    } else {
      this.header.style.setProperty('--logo-width', `${this.headerLogo.getBoundingClientRect().width}px`);
    }
  }

  _initTransparency() {
    document.body.removeAttribute('data-transparent-header');

    // We only want to change transparency if the header is sticky
    // and if the first section is a banner.
    if (this.firstSectionIsBanner()) {
      if (this.sticky && this.transparent) {
        document.body.dataset.transparentHeader = true;
        this.scrollObserver = new IntersectionObserver((entries) => this._setTransparency(entries));
        this.scrollObserver.observe(this.scrollObserverPoint);
      } else if (this.transparent) {
        document.body.dataset.transparentHeader = true;
      }
    }
  }

  _setTransparency(entries) {
    if (!entries) { return; }

    if (entries[0].isIntersecting || !this.sticky) {
      document.body.dataset.transparentHeader = true;
    } else {
      document.body.dataset.transparentHeader = false;
    }

    this._recordHeaderHeight();
  }

  _updateCartCount(e) {
    const count = e.detail.count;
    this.cartCount.innerHTML = count;
  }

  firstSectionIsBanner() {
    const firstSection = document.querySelector('main section');
    return firstSection && firstSection.dataset.banner === 'true';
  }

  onSectionUnload() {
    this.headerNav.unload();
    this.abortController.abort();

    if (this.scrollObserver) {
      this.scrollObserver.disconnect();
    }

    document.body.removeAttribute('data-transparent-header');
  }
}
